/** @jsx jsx */
/* eslint-disable no-use-before-define,no-mixed-operators */
import { jsx } from '@emotion/core'
import React from 'react'
import { Section, getState, YES_NO, fmt, parseHtml, Flyout, matIcon} from '../twd'
import { useBondDetail } from './use-bond-detail'
import { sectionCss, sectionListCss } from './style'

const state = getState('bond_detail.redemption_features', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const [showCall, setShowCall] = React.useState(false)
    const [showSink, setShowSink] = React.useState(false)
    const [showPut, setShowPut] = React.useState(false)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])

    const { issue } = useBondDetail()
    let invType = issue.type
    let isMBS = ['O', 'R', 'K'].indexOf(invType)>=0

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-redemption-features'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>
        <div className="row"><div className="col-xs-12">
            <Section
                title="Redemption features"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <dl css={sectionListCss}>
                    <dt>Redemption type</dt>
                    <dd dangerouslySetInnerHTML={{
                        __html:[
                            parseHtml(issue.callfeaturesText),
                            parseHtml(issue.callMakeWholeDisplay)
                        ].filter(Boolean)
                        .join('<br/>') || fmt.emptyHtml
                    }} />

                    <dt>Callable</dt>
                    <dd>{YES_NO[isMBS ? 'N' : issue.callableInd] || fmt.empty()}</dd>

                    <dt>Putable</dt>
                    <dd>{YES_NO[issue.putableInd] || fmt.empty()}</dd>

                    <dt>Sinking fund</dt>
                    <dd>{YES_NO[issue.nextSink ? 'Y' : 'N']}</dd>

                    <dt>Conditional call</dt>
                    <dd>{parseHtml(issue.conditionalcallreason) || fmt.empty()}</dd>

                    <dt>Conditional call in full</dt>
                    <dd>{YES_NO[issue.calledInFullInd] || fmt.empty()}</dd>

                    <dt>Next call date</dt>
                    <dd>{parseHtml(issue.calldaysnoticeText) || fmt.empty()}</dd>

                    <dt>Next put date</dt>
                    <dd>{fmt.mdy(issue.nextOptPutDt)}</dd>

                    <dt>Put type</dt>
                    <dd>{(() => {
                        let p = getPutType(issue)
                        if (!p) return fmt.empty()

                        return <React.Fragment>
                            {p.label}
                            &nbsp;
                            {p.tip && <Flyout html={p.tip} />}
                        </React.Fragment>
                    })()}</dd>

                    <dt>Next sink</dt>
                    <dd>{fmt.mdy(issue.nextSink)}</dd>

                    <dt>Make whole end date</dt>
                    <dd>{fmt.mdy(issue.callMakeWholeExp)}</dd>

                    <dt>Make whole benchmark/spread</dt>
                    <dd>{fmt.nullIf(issue.callMakeWholeBenchmark,'Unknown') || fmt.empty()} / {fmt.nullIf(issue.callMakeWholeSpread, '-') || fmt.empty()}</dd>

                    <dt>Make whole yield</dt>
                    <dd>{fmt.ytw(issue.callMakeWholeYield)}</dd>

                    <dt>Call schedule</dt>
                    <dd>
                    {
                        (issue.displayCallSched==='Y' && issue.callList && issue.callList.length > 0
                        && <button className="link-button"
                            onClick={() => setShowCall(!showCall)}
                        >
                        {matIcon(showCall ? 'keyboard_arrow_down': 'keyboard_arrow_right', '')}View schedule
                        </button>) || fmt.empty()
                    }
                    {
                        showCall && issue.displayCallSched==='Y' && issue.callList && issue.callList.length > 0
                        && issue.callList.map((s, i) => <p key={i}>
                                {fmt.mdy(s.callDt)}@ {fmt.price3(s.callPrice)}
                            </p>)
                    }
                    </dd>

                    <dt>Put schedule</dt>
                    <dd>
                    {
                        (issue.displayPutSchedule==='Y' && issue.putSchedule && issue.putSchedule.length > 0
                        && <button className="link-button"
                            onClick={() => setShowPut(!showPut)}
                        >
                        {matIcon(showPut ? 'keyboard_arrow_down': 'keyboard_arrow_right', '')}View schedule
                        </button>) || fmt.empty()
                    }
                    {
                        showPut && issue.displayPutSchedule==='Y' && issue.putSchedule && issue.putSchedule.length > 0
                        && issue.putSchedule.map((s, i) => <p key={i}>
                                {fmt.mdy(s.dt)}@ {fmt.qty(s.price)}
                            </p>)
                    }
                    </dd>

                    <dt>Sink schedule</dt>
                    <dd>
                    {
                        (issue.sinkSchedule && issue.sinkSchedule.length > 0
                        && <button className="link-button"
                            onClick={() => setShowSink(!showSink)}
                        >
                        {matIcon(showSink ? 'keyboard_arrow_down': 'keyboard_arrow_right', '')}View schedule
                        </button>) || fmt.empty()
                    }
                    {
                        showSink && issue.sinkSchedule && issue.sinkSchedule.length > 0
                        && issue.sinkSchedule.map((s, i) => <p key={i}>
                                {fmt.mdy(s.dt)}@ {fmt.qty(s.amt)}
                            </p>)
                    }
                    </dd>
                    <dt>Security Notes</dt>
                    <dd>{fmt.initCap(issue.note) || fmt.empty()}</dd>
            </dl>
            </Section>
        </div></div>

        <div className="xs-show row vertical-offset-sm"></div>
    </div>

    </React.Fragment>
}

let getPutType = ({conditionalputreason, condPutFeatures, putType}) => {
    return (conditionalputreason && conditionalputreason==='Death of holder' && PUT_TYPE_CODE.D)
        || (conditionalputreason && { label:parseHtml(conditionalputreason) })
        || PUT_TYPE_CODE[condPutFeatures]

}

let PUT_TYPE_CODE = {
    'A': {
        label: 'Convenant violation',
    },
    'B': {
        label: 'Change of control',
    },
    'C': {
        label: 'Rating downgrade',
    },
    'D': {
        label: 'Death of holder',
        tip: 'Survivors Options may vary among issuers. Please review the Prospectus and the Pricing Supplement for additional information regarding the Survivors Option.',
    },
    'Z': {
        label: 'Other',
    },
}
